import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./PaymentStatus.css"; // Debe coincidir exacto con el nombre del archivo

const PaymentPending = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Capturamos el ID para que el cliente tenga un soporte visual
  const paymentId = searchParams.get("payment_id");

  return (
    <div className="status-container pending">
      <div className="status-card">
        <div className="status-icon">⏳</div>
        <h1>Pago en proceso</h1>
        <p>Tu pago está siendo procesado por Mercado Pago.</p>
        
        <div className="pending-info">
          <p>Si pagaste en efectivo, recuerda que puede tardar hasta 24 horas en acreditarse.</p>
          {paymentId && <p className="payment-ref">Referencia de seguimiento: {paymentId}</p>}
        </div>

        <p>Te notificaremos por correo electrónico una vez se confirme la transacción.</p>
        
        <button className="status-btn" onClick={() => navigate("/")}>
          Volver a la tienda
        </button>
      </div>
    </div>
  );
};

export default PaymentPending;